import { render, staticRenderFns } from "./SelectedThreat.vue?vue&type=template&id=42ea9d4e&scoped=true&"
import script from "./SelectedThreat.vue?vue&type=script&lang=js&"
export * from "./SelectedThreat.vue?vue&type=script&lang=js&"
import style0 from "./SelectedThreat.vue?vue&type=style&index=0&id=42ea9d4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ea9d4e",
  null
  
)

export default component.exports